import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldSchema } from '@lsq-frontend/remote-services/ar-app';
import { Color, Icons, ModalService } from '@lsq-frontend/common-ui';
import { DrApplicationService } from '../../../service/dr-application-service';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'add-document-modal',
    templateUrl: './add-document-modal.component.html',
    styleUrls: ['./add-document-modal.component.scss']
})
export class AddDocumentModal {
    public formGroup: FormGroup;
    public fieldSchema: FieldSchema;
    public schemaType: string;
    public isDuplicatedNameSubject = new BehaviorSubject<boolean>(false);
    public isDuplicatedName$ = this.isDuplicatedNameSubject.asObservable();
    private _documentFieldSchemas: FieldSchema[];
    public icons = Icons;
    public color = Color;

    constructor(private _modalService: ModalService, private _arService: DrApplicationService) {
        this.formGroup = this._modalService.modal.data.formGroup;
        this.fieldSchema = this._modalService.modal.data.fieldSchema;
        this.schemaType = this._modalService.modal.data.schemaType;
        if (!this._modalService.modal.data.isEditDocument) {
            this.getSchemaDocumentName();
            this.formGroup.valueChanges.subscribe((value) => {
                if (value.documentName) {
                    let foundMatch = false;

                    for (const fieldSchema of this._documentFieldSchemas) {
                        if (value.documentName === fieldSchema.label) {
                            foundMatch = true;
                            break;
                        }
                    }

                    this.isDuplicatedNameSubject.next(foundMatch);
                }
            });
        }
    }

    public getSchemaDocumentName() {
        // Verify duplicated document request name
        const stageSchemaOpenDocumentId = this._arService.getOpenDocumentsStageID();
        const stageSchemaDocumentDefaultId = this._arService.getDocumentsStageDefaultID();
        const stageSchemas = this._arService.getProspectSchema().stageSchemas;
        let stageSchema = stageSchemas.filter(
            (stageSchema) => stageSchema.id === stageSchemaOpenDocumentId
        );
        if (stageSchema.length === 0) {
            stageSchema = stageSchemas.filter(
                (stageSchema) => stageSchema.id === stageSchemaDocumentDefaultId
            );
        }
        this._documentFieldSchemas = stageSchema[0].fieldSchemas.filter(
            (fieldSchema: FieldSchema) =>
                fieldSchema.fieldType === FieldSchema.FieldTypeEnum.DocumentField
        );
    }

    public fileOptions = [
        {
            label: 'All',
            value: '*'
        },
        {
            label: 'PDF',
            value: '.pdf'
        },
        {
            label: 'PNG',
            value: '.png'
        },
        {
            label: 'JPG',
            value: '.jpg'
        },
        {
            label: 'GIF',
            value: '.gif'
        },
        {
            label: 'CSV',
            value: '.csv'
        },
        {
            label: 'XLS',
            value: '.xls'
        },
        {
            label: 'XLSX',
            value: '.xlsx'
        }
    ];
}
